<div class=" relative h-screen w-screen z-0 overflow-auto bg-no-repeat bg-custom-bg">
    <div class="absolute top-0 bottom-0 left-0 h-auto w-full  dark:bg-black bg-opacity-40 backdrop-blur-sm z-[-1]"></div>

    <div class="flex h-screen dashboard-partition" [ngClass]="{isSidebarOpen}">
        <!-- Sidebar -->
        <div class="absolute h-screen w-[300px] dark:bg-white transition-transform duration-300 ease-in-out max-md:w-[100px] transform -translate-x-full z-10 sidebar-container"
            [ngClass]="{'translate-x-0': isSidebarOpen}">
            <sidebar></sidebar>
        </div>

        <div class="flex-1 overflow-y-auto overflow-x-hidden transition-all duration-300 ease-in-out"
            [ngClass]="{'ml-[300px] max-md:ml-[100px]': isSidebarOpen}">
            <!-- Topbar -->
            <div class="h-[60px] w-full bg-white flex-shrink-0 sticky top-0 z-50">
                <navbar (toggleSidebarEvent)="toggleSidebar()" [isSidebarOpen]="isSidebarOpen"></navbar>
            </div>

            <div class="z-10">
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</div>
